import { findAdapterFromAssetFamily } from '../fetcher/adapter/utils/findAdapterFromAssetFamily';
import { useCallback } from 'react';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';

/**
 * Hook that subscribes to PROPERTY_DEFINITIONS_UPDATED on the CRM message bus,
 * clears resolver and adapter caches, and refetches data for that asset family.
 *
 * @param fetchMore - function to re-fetch data when definitions change
 * @param props - fetcher props
 */
export function useRefetchOnPropertyDefinitionsUpdated(fetchMore, props) {
  const onPropertyDefinitionsUpdated = useCallback(({
    objectTypeId
  }) => {
    // Clear adapter cache for the updated asset family
    const adapter = findAdapterFromAssetFamily(objectTypeId);
    adapter === null || adapter === void 0 || adapter.clearCache(objectTypeId, props);

    // Trigger re-fetch of data for this asset family
    void fetchMore({
      variables: {
        assetFamily: objectTypeId
      }
    });
  }, [fetchMore, props]);
  useOnCrmMessageTopic('PROPERTY_DEFINITIONS_UPDATED', onPropertyDefinitionsUpdated);
}